import axios from 'axios';
import { axiosClient } from './axiosClient.js';
// Set http client timeout, as by default axios waits forever for responses
// Request that needs to be resolved and throws error on fail
export const createGetRequest = (url, config) => axios.get(url, config);
export const createPostRequest = (url, data, requestOptions) => axiosClient().post(url, data, requestOptions);
export const createPutRequest = (url, data, requestOptions) => axiosClient().put(url, data, requestOptions);
//# sourceMappingURL=request.js.map